/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import KeycloakProvider from '@maas-tools/keycloak'
import ReactDOM from 'react-dom'
import { ENVIRONMENT, FLAG_ENABLE_SERVER_MOCK } from 'core/common/constants/env'
import Loading from 'core/components/Loading'
import AppError from 'core/containers/App/AppError'
import AppTheme from 'core/containers/App/AppTheme'
import 'core/common/i18n'
import App from './App'
import reportWebVitals from './reportWebVitals'
import '@maas-components/fonts'

if (
  (ENVIRONMENT === 'development' || ENVIRONMENT === 'staging') &&
  FLAG_ENABLE_SERVER_MOCK === 'true'
) {
  const { worker } = require('__mocks__/browser')
  worker.start({ onUnhandledRequest: 'bypass' })
}

ReactDOM.render(
  <AppTheme>
    <AppError>
      <KeycloakProvider LoadingComponent={<Loading />}>
        <App />
      </KeycloakProvider>
    </AppError>
  </AppTheme>,
  document.getElementById('root')
)

reportWebVitals()
